import { getWorkflowStateEntry } from './mutableWorkflowOverlay.js';
export function resolveWorkflowStateChain(workflowState, start, opts) {
    const maxDepth = opts?.maxDepth ?? 50;
    const visited = new Set();
    const path = [];
    let current = start;
    for (let depth = 0; depth <= maxDepth; depth++) {
        path.push(current);
        const visitKey = `${current.stepKey}::${current.roleName}`;
        if (visited.has(visitKey)) {
            return { status: 'unresolved', reason: 'cycle', path };
        }
        visited.add(visitKey);
        const entry = getWorkflowStateEntry(workflowState, current);
        if (!entry) {
            return { status: 'unresolved', reason: 'not-found', path };
        }
        if (entry.workflowStateEntryKind === 'materializedResource') {
            return { status: 'materializedResource', entry, path };
        }
        if (entry.workflowStateEntryKind === 'externalInputPotential') {
            return { status: 'externalInputPotential', entry, path };
        }
        current = entry.toolStepRoleAddress;
    }
    return { status: 'unresolved', reason: 'depth-exceeded', path };
}
